"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.videoQualityFilter = exports.channelFilter = exports.languageFilter = exports.kindFilter = exports.mapToGenericThumbnail = exports.getDefaultAutoTrack = exports.mapToVideoTrack = exports.mapToTextTrack = exports.mapToAudioTrack = void 0;
var player_base_1 = require("@24i/player-base");
function mapToTrack(track, currentTrack) {
    var id = track.id, audioId = track.audioId, _a = track.roles, roles = _a === void 0 ? [] : _a, kind = track.kind, label = track.label, language = track.language;
    var selected = currentTrack && currentTrack.audioId
        ? currentTrack.audioId === audioId
        : (currentTrack === null || currentTrack === void 0 ? void 0 : currentTrack.id) === id;
    return {
        id: "" + (audioId !== null && audioId !== void 0 ? audioId : id),
        kind: (roles[0] || kind || player_base_1.TrackKind.Undefined),
        label: label,
        language: language,
        default: undefined,
        selected: selected,
        extra: track,
    };
}
function mapToAudioTrack(track, currentTrack) {
    var audioBandwidth = track.audioBandwidth, channelsCount = track.channelsCount;
    return __assign(__assign({}, mapToTrack(track, currentTrack)), { bitrate: audioBandwidth, channels: channelsCount, type: player_base_1.TrackType.Audio });
}
exports.mapToAudioTrack = mapToAudioTrack;
function mapToTextTrack(track, currentTrack) {
    return __assign(__assign({}, mapToTrack(track, currentTrack)), { forced: undefined, type: player_base_1.TrackType.Text });
}
exports.mapToTextTrack = mapToTextTrack;
function mapToVideoTrack(track) {
    return __assign(__assign({}, mapToTrack(track)), { id: String(track.id), kind: player_base_1.TrackKind.Variant, label: track.height + "p", selected: false, width: track.width, height: track.height, frameRate: track.frameRate, bitrate: track.videoBandwidth || track.bandwidth, type: player_base_1.TrackType.Video });
}
exports.mapToVideoTrack = mapToVideoTrack;
function getDefaultAutoTrack() {
    return {
        id: '-1',
        kind: player_base_1.TrackKind.Variant,
        default: undefined,
        label: 'Auto',
        selected: false,
        width: 0,
        height: 0,
        frameRate: 0,
        bitrate: 0,
        type: player_base_1.TrackType.Video,
    };
}
exports.getDefaultAutoTrack = getDefaultAutoTrack;
function mapToGenericThumbnail(thumbnail) {
    return {
        url: thumbnail.uris[0],
        x: thumbnail.positionX,
        y: thumbnail.positionY,
        start: thumbnail.startTime,
        end: thumbnail.startTime + thumbnail.duration,
        width: thumbnail.width,
        height: thumbnail.height,
        imageWidth: thumbnail.imageWidth,
        imageHeight: thumbnail.imageHeight,
    };
}
exports.mapToGenericThumbnail = mapToGenericThumbnail;
var kindFilter = function (candidateAudioTrack, currentAudioTrack) {
    return currentAudioTrack.kind && currentAudioTrack.kind !== 'undefined'
        ? candidateAudioTrack.roles.indexOf(currentAudioTrack.kind) > -1
        : true;
};
exports.kindFilter = kindFilter;
var languageFilter = function (candidateAudioTrack, currentAudioTrack) {
    return currentAudioTrack.language &&
        currentAudioTrack.language !== 'und' &&
        currentAudioTrack.language
        ? candidateAudioTrack.language === currentAudioTrack.language
        : true;
};
exports.languageFilter = languageFilter;
var channelFilter = function (candidateAudioTrack, currentAudioTrack) { return candidateAudioTrack.channelsCount === currentAudioTrack.channels; };
exports.channelFilter = channelFilter;
var videoQualityFilter = function (candidateAudioTrack, currentVideoTrack) {
    if (candidateAudioTrack.height && (currentVideoTrack === null || currentVideoTrack === void 0 ? void 0 : currentVideoTrack.height)) {
        return candidateAudioTrack.height === currentVideoTrack.height;
    }
    else if (currentVideoTrack) {
        return (candidateAudioTrack.videoBandwidth === currentVideoTrack.bitrate ||
            candidateAudioTrack.bandwidth === currentVideoTrack.bitrate);
    }
    return true;
};
exports.videoQualityFilter = videoQualityFilter;
//# sourceMappingURL=tracks.js.map